export default __webpack_public_path__ + "static/media/i_wdt_c_2.99f89190.mp3";